import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class Okrhistoryrevision extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            search: [],
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            historyRev: [],
            er_title: ''
        };
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    SnippetHistoryRevision() {
        fetch(this.state.apiUrl + '/OkrRest/OkrHistoryRevision/id/' + this.props.match.params.id + '/userAuthKey/' + this.state.userAuthKey + '/noteId/' + this.props.match.params.noteId)
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.decrypt(responseJson, 1);
                console.log(responseJson.historyRev);
                this.setState({
                    historyRev: responseJson.historyRev,
                })
            })
    }

    goBack() {
        window.location.href = '/updateokr/' + this.props.match.params.id;
    }

    componentDidMount() {
        document.title = "Intranet | History Revision";
        this.SnippetHistoryRevision();
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div >
                <Header brecum_name="ER's" brecum_page="OKR" />
                <div class="right_col">
                    <div className="intranet_body">
                        <div class="title mob"><HeaderMob page_name="OKR" /></div>
                        <label></label>
                        {/*loop start for revision  */}
                        {
                            this.state.historyRev.map((ErHistory, key) =>
                                <div>
                                    <div class="row">
                                        <div class="col-md-3 col-xs-12"><b>Revision </b></div>
                                        <div class="col-md-6 col-xs-12">{ErHistory.created_date} by {ErHistory.user_name}</div>
                                    </div>
                                    <br />
                                    <div class="row">
                                        <div class="col-md-3 col-xs-12"><b>{ErHistory.type == 1 ? 'Description' : (ErHistory.type == 4 ? 'Note' : '')}</b></div>
                                        <div class="details_des col-md-6"><div dangerouslySetInnerHTML={{ __html: ErHistory.value }} /></div>
                                    </div>
                                    <div class="row">
                                        <hr></hr>
                                    </div>
                                </div>
                            )
                        }

                        {/* loop end for revision  */}
                        <div class="top-row border-bottom hidden-xs">
                            <button type="button" className="btn btn-blue" onClick={() => this.goBack()} >Back</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Okrhistoryrevision;


// WEBPACK FOOTER //
// ./src/components/okr/okrhistoryrevision.js